import { log } from '@intigral/utils';
import h from '../helpers/common';
import { getStreamingUrlByAssetType, setLockedFlag } from './transformResponse/common';
export type TransformedVOD = {
    productId?: any;
    Id: string;
    paId: string;
    listingId: string | null;
    guid: string;
    text: string;
    textEn: string;
    name: string;
    description: string;
    descriptionEn: string;
    image: string;
    image_landscape: string;
    year: number;
    tags: Array<{ scheme: string; title: string }>;
    genre: string[];
    provider: string[];
    categories: string[];
    ratings: string;
    duration: number;
    language: string;
    programType: string;
    tvSeasonEpisodeNumber: number | null;
    streamingUrl: string | null;
    trailer: string | null;
    trailerMediaUrl: string | null;
    seriesId: string | null;
    tvSeasonNumber: number | null;
    tvSeasonId: string | null;
    subscriptionGuids: string[] | null;
    category: string;
    mediaId: string | null;
    promoType: boolean;
    introEt: number | null;
    introSt: number | null;
    outroEt: number | null;
    outroSt: number | null;
    isLocked?: boolean;
    meta?: any;
};

export function transformVOD(vod, providers): TransformedVOD {
    let contentObject = vod.media;
    let trailer = null;
    let streamingUrl = null;
    let trailerMediaUrl = null;
    if (
        vod.media &&
        vod.media.length > 0 &&
        !!vod.media[0] &&
        typeof vod.media[0].content !== 'undefined' &&
        vod.media[0].content !== null
    ) {
        contentObject = vod.media[0].content;
        let trailerM3U8 = [];
        let vodStreamingUrl = [];
        let trailerMedia = [];

        trailerM3U8 = contentObject.filter((cnt) => {
            return cnt.assetTypes[0] === 'Trailer-MP4';
        });

        trailerMedia = contentObject.filter((cnt) => {
            return cnt.assetTypes[0] === 'Trailer';
        });

        vodStreamingUrl = contentObject.filter((cnt) => {
            return cnt.assetTypes[0] === 'Video' && cnt.format === 'M3U';
        });

        if (trailerM3U8.length > 0) {
            trailer = trailerM3U8[0].streamingUrl;
        }

        if (trailerMedia?.length > 0) {
            trailerMediaUrl = trailerMedia?.length > 0 ? trailerMedia[0].releases?.[0]?.url ?? null : null;
            // trailerMediaUrl = trailerMedia[0].releases[0]?.url;
        }

        if (vodStreamingUrl.length > 0) {
            streamingUrl = vodStreamingUrl.length > 0 ? vodStreamingUrl[0].releases?.[0]?.url ?? '' : null;
            // streamingUrl = vodStreamingUrl[0].releases[0] ? vodStreamingUrl[0].releases[0].url : '';
        }
    }

    const vodTags: any[] = vod.tags || []; // Sometimes vod.tags is undefined

    let result = {
        Id: vod.id,
        paId: vod.id,
        listingId: vod.listingId ?? null,
        guid: vod.guid ? vod.guid : '',
        text: h.getLang() === 'en' ? vod.title : vod?.titleLocalized?.ar,
        textEn: vod.title,
        name: vod.title,
        description: h.getLang() === 'en' ? vod.description : vod?.descriptionLocalized?.ar,
        descriptionEn: vod.description,
        image: vod?.thumbnails
            ? vod?.thumbnails['portrait-highestResolution']
                ? vod?.thumbnails['portrait-highestResolution']?.url
                : ''
            : vod?.images[1]?.url,
        image_landscape: vod?.thumbnails
            ? vod?.thumbnails['landscape-highestResolution']
                ? vod?.thumbnails['landscape-highestResolution']?.url
                : ''
            : vod?.images[0]?.url,
        year: vod.year,
        tags: vodTags,
        genre: vodTags.filter((i) => i.scheme === 'Genre' && i.title).map((el) => el.title),
        provider: vodTags.filter((i) => i.scheme === 'Categories' && i.title in providers).map((i) => i.title),
        categories: vodTags.filter((i) => i.scheme === 'Categories' && !(i.title in providers)).map((i) => i.title),
        ratings: h.getGenreRating(vod.ratings),
        duration: vod.runtime,
        language: vod.languages ? vod.languages[0] : '',
        programType: vod.programType,
        tvSeasonEpisodeNumber: vod.tvSeasonEpisodeNumber,
        streamingUrl: streamingUrl,
        trailer: trailer,
        trailerMediaUrl: trailerMediaUrl,
        seriesId: vod.seriesId,
        tvSeasonNumber: vod.tvSeasonNumber,
        tvSeasonId: vod.tvSeasonId,
        subscriptionGuids: vod?.pl1$subscriptionGuids ?? vod?.subGuids ?? null,
        category: 'VOD',
        mediaId: vod.media && vod.media.length > 0 ? vod.media[0].id : null,
        promoType: false,
        introEt: vod.pl1$introEt,
        introSt: vod.pl1$introSt,
        outroEt: vod.pl1$outroEt,
        outroSt: vod.pl1$outroSt,
        categoryType: vod?.pl1$categoryType ?? null,
        adEnabled: vod?.pl1$adEnabled ?? null,
        useCaseId: vod?.useCaseId,
        timeCode: vod.timeCode ?? 0,
        vodTrailer: getStreamingUrlByAssetType(vod?.content ?? [], ['Trailer-MP4']),
    };

    result = setLockedFlag(result);

    return result;
}
